import { render } from "./ActivityForm.vue?vue&type=template&id=0d31e0ca&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&lang=js"
export * from "./ActivityForm.vue?vue&type=script&lang=js"

import "./ActivityForm.vue?vue&type=style&index=0&id=0d31e0ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d31e0ca"]])

export default __exports__